import { parsePhoneNumber } from "react-phone-number-input";
import countryToCurrency from "country-to-currency";

/**
 * URL path params often lose "+" (decoded as space or stripped).
 * Restore E.164 so parsePhoneNumber can resolve country/currency.
 */
export const normalizePhoneNumber = (value) => {
  if (value == null || value === "") return "";
  let phone = String(value).trim().replace(/\s+/g, "");
  try {
    phone = decodeURIComponent(phone);
  } catch (_) {
    // keep as-is if already decoded
  }
  phone = phone.trim().replace(/\s+/g, "");
  if (!phone) return "";
  if (!phone.startsWith("+")) {
    phone = `+${phone.replace(/^\+/, "")}`;
  }
  return phone;
};

export const resolveCurrencyFromPhone = (value) => {
  const normalized = normalizePhoneNumber(value);
  if (!normalized) {
    return { phoneCode: "", nationalNumber: "", sourceCurrency: "", normalized: "" };
  }

  let parsed = null;
  try {
    parsed = parsePhoneNumber(normalized);
  } catch (_) {
    parsed = null;
  }

  const currencyMap = countryToCurrency?.default ?? countryToCurrency;
  const sourceCurrency =
    parsed?.country && currencyMap?.[parsed.country] ? currencyMap[parsed.country] : "";

  return {
    normalized,
    phoneCode: parsed?.countryCallingCode ? `+${parsed.countryCallingCode}` : "",
    nationalNumber: parsed?.nationalNumber ?? "",
    sourceCurrency,
  };
};
